
import { Component, Prop, Vue } from 'vue-property-decorator';
import { setFeatureVersion } from '@/config/atlasFeatures';
import Config from '../models/config';
import List from '../collections/list';
import HeaderTitle from '../components/HeaderTitle.vue';
import { StoreModel } from '@/models/store';
import UserChangePassword from '@/components/UserChangePassword.vue';
import ActionButton from '@/components/ActionButton.vue';
import SpreadsheetSettings from '../components/SpreadsheetSettings.vue';
import PluginConfiguration from '@/components/PluginConfiguration.vue';
import GoogleDriveSettings from '@/components/GoogleDriveSettings.vue';
import NotificationContact from '@/components/NotificationContact.vue';
import MultiStoreSettings from '@/components/MultiStoreSettings.vue';
import ReorderParamSetting from '@/components/ReorderParamSetting.vue';
import InventoryParamSetting from '@/components/InventoryParamSetting.vue';
import IncomingInventorySettings from '@/components/IncomingInventorySettings.vue';
import { MeasureList } from '@/collections/measures';
import { EventBus } from '@/main';
import ManageSuppliers from "@/components/ManageSuppliers.vue";
import BundleMapping from "@/components/BundleMapping.vue";
import InventoryTransferSettings from "@/components/InventoryTransferSettings.vue";
import AddChatChannel from "@/components/AddChatChannel.vue";
import BundleMappingSettings from '@/components/BundleMappingSettings.vue';
import InventoryForecastSettings from '@/components/InventoryForecastSettings.vue';
import LocationRestrictionSettings from '@/components/LocationRestrictionSettings.vue';
import DataSyncStatusBanner from '@/components/DataSyncStatusBanner.vue';
import Permission from "@/components/Permission.vue";
import PurchaseOrderLineItemColumns from '@/views/settings/PurchaseOrderLineItemColumns.vue';
import TaxTypeSettings from '@/components/TaxTypeSettings.vue';
import LandedCostSettings from '@/views/settings/LandedCostSettings.vue';
import PoEmailTemplate from '@/views/settings/PoEmailTemplate.vue';
import AtlasOptInDialog from '@/components/AtlasOptInDialog.vue';

@Component({
  components: {
    HeaderTitle,
    UserChangePassword,
    ActionButton,
    SpreadsheetSettings,
    PluginConfiguration,
    GoogleDriveSettings,
    NotificationContact,
    MultiStoreSettings,
    ReorderParamSetting,
    InventoryParamSetting,
    IncomingInventorySettings,
    ManageSuppliers,
    BundleMappingSettings,
    DataSyncStatusBanner,
    InventoryTransferSettings,
    AddChatChannel,
    InventoryForecastSettings,
    LocationRestrictionSettings,
    Permission,
    PurchaseOrderLineItemColumns,
    TaxTypeSettings,
    LandedCostSettings,
    PoEmailTemplate,
    AtlasOptInDialog,
  },
})
export default class Setting extends Vue {
  public showAtlasOptIn: boolean = false;
  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  public success: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public config: Config = new Config();
  public forceShowingWaringScheduleData: boolean = true;
  public emails: string[] = [];
  public currentValueEmail: string | null = null;
  @Prop({ default: () => [] })
  public timeRangeLimit!: string[];
  @Prop({ default: false })
  public isAthenaFinished!: boolean;
  @Prop({default: null})
  public app!: any;
  @Prop({ default: () => new MeasureList() })
  public measures!: MeasureList;
  public pageTitles: any = {
    'contact': 'Contact information',
    'bundle-product-mapping': 'Bundle product mapping',
    'reorder-parameters': 'Reorder parameters',
    'stocky': 'Stocky Integration',
    'multi-store-settings': 'Multiple store data combination',
    'multi-store-activate': 'Accept multiple store data combination request',
    'manage-suppliers': 'Manage suppliers',
    'incoming-inventory': 'Incoming inventory',
    'internal-inventory-transfer-settings': 'Internal inventory transfer settings',
    'inventory-forecast': 'Inventory forecast settings',
    'location-restrictions': 'Location restrictions',
    'purchase-order': 'Purchase Orders',
  };
  public poSettingsTab: number = 0;
  public isPinMenu: boolean = true;
  public demoStoreName: string = 'assisty-demo.myshopify.com';

  public async created() {
    this.loading = true;
    this.checkIsMenuPinned();
    // Open specific PO sub-tab if query param is provided
    const poTab = this.$route.query.poTab;
    if (poTab === 'columns') {
      this.poSettingsTab = 2;
    } else if (poTab === 'landed-cost') {
      this.poSettingsTab = 1;
    } else if (poTab === 'tax') {
      this.poSettingsTab = 0;
    }
    try {
      await this.config.load();
      this.error = false;
      this.success = true;
      this.loading = false;
    } catch (e: any) {
      this.loading = false;
      this.error = true;
      this.success = false;
      return;
    }
    EventBus.$on("pin-menu", async (isPin: any) => {
      this.pinMenu(isPin);
    });
  }

  public checkIsMenuPinned() {
    //get isPinMenu from local storage
    let isPinMenu = localStorage.getItem("isPinMenu") || "true";
    if (isPinMenu === "true") {
      this.isPinMenu = true;
    } else {
      this.isPinMenu = false;
    }
  }

  public pinMenu(isPin: boolean = false) {
    if (isPin) {
      this.isPinMenu = true;
    } else {
      this.isPinMenu = false;
    }
  }

  public reloadReportData() {
    EventBus.$emit('reload-report-data');
  }

  public get currentTabTitle() {
    return this.pageTitles[this.currentTab];
  }

  get currentTab() {
    let tab = this.$route.params.tab;
    const tabs = [
    'contact',
    'chat-channel',
    'bundle-product-mapping',
    'reorder-parameters',
    'stocky',
    'multi-store-settings',
    'multi-store-activate',
    'manage-suppliers',
    'incoming-inventory',
    'internal-inventory-transfer-settings',
    'inventory-forecast',
    'location-restrictions',
    'purchase-order',
  ];
    if (tabs.includes(tab)) {
      return tab;
    } else {
      return 'contact';
    }
  }

  public remove(item: string) {
    this.emails.splice(this.emails.indexOf(item), 1);
    this.emails = [...this.emails];
  }

  private sleep(ms: number) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  public switchToAtlasSettings() {
    setFeatureVersion('settings', 'atlas');
    this.$router.push('/assistant/setup');
  }
}
